import type { CodeType } from '../interface/codes';
import type { UiEventBus } from './uiEventBus';

export type CodingScreenConsole = {
  openAddCode?: (codeType?: CodeType) => boolean;
};

declare global {
  interface Window {
    cmxCodingScreen?: CodingScreenConsole;
  }
}

type OpenAddCode = NonNullable<CodingScreenConsole['openAddCode']>;

const installed: OpenAddCode[] = [];
let foreign: OpenAddCode | undefined;

export function installConsole(bus: UiEventBus, host: Window = window): () => void {
  const target = host.cmxCodingScreen ?? (host.cmxCodingScreen = {});
  if (installed.length === 0) foreign = target.openAddCode;
  const mine: OpenAddCode = (codeType = 'ICD') => bus.emit('addCode.open', { codeType });
  installed.push(mine);
  target.openAddCode = mine;
  return () => {
    const at = installed.indexOf(mine);
    if (at < 0) return;
    installed.splice(at, 1);
    const top = installed[installed.length - 1] ?? foreign;
    if (top) {
      target.openAddCode = top;
    } else {
      delete target.openAddCode;
    }
    if (installed.length === 0) foreign = undefined;
  };
}
